// extracted by mini-css-extract-plugin
export default {"wrapper":"ShowInventoryData_wrapper__ANXoa","close":"ShowInventoryData_close__W4-6z"};